import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Events from "./views/Events.vue";
import Event from "./views/Event.vue";
import Details from "./views/EventDetails.vue"
import EventManagement from "./views/EventManagement.vue";
import Agenda from "./views/Agenda.vue";
import Speakers from "./views/Speakers.vue";
import Sponsors from "./views/Sponsors.vue";
import Venues from "./views/Venues.vue";
import Guestlist from "./views/Guestlist.vue";
import Tickets from "./views/Tickets.vue";
import Design from "./views/Design.vue";
import Manage from "./views/Manage.vue";
import Exhibitors from "./views/Exhibitors.vue";
import CheckIn from "./views/Check-in.vue";
import AddAttendees from "./views/AddAttendees.vue";
import AddGuest from "./views/AddGuest.vue";
import EmailAttendees from "./views/EmailAttendees";
import Attendees from "./views/Attendees.vue";
import Badges from "./views/Badges.vue";
import Checkin from "./views/Checkin.vue";
import Reports from "./views/Reports.vue";
import Preview from "./views/Preview.vue";
import Profile from "./views/Profile.vue";
import Help from "./views/Help.vue";
import Orders from "./views/Orders.vue";
import EventOrders from "./views/EventOrders.vue";
import OrderDetails from "@/views/OrderDetails.vue";
import Pages from "@/views/Pages.vue";

import firebase from "firebase";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Login Register",
      component: Home,
    },
    {
      path: "/events",
      name: "Events",
      component: Events,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/content",
      name: "Event",
      component: Event,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/management",
      name: "Event Management",
      component: EventManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/agenda",
      name: "Event Agenda",
      component: Agenda,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/speakers",
      name: "Event Speakers",
      component: Speakers,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/sponsors",
      name: "Event Sponsors",
      component: Sponsors,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/details",
      name: "Event Details",
      component: Details,
      meta: {
        requiresAuth: true,
      },
    },
    
    {
      path: "/event/:id/venues",
      name: "Event Venues",
      component: Venues,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/guestlist",
      name: "Event Guestlist",
      component: Guestlist,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/tickets",
      name: "Tickets",
      component: Tickets,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/attendees/add",
      name: "Create Order",
      component: AddAttendees,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/guest/add",
      name: "Create Guest",
      component: AddGuest,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/attendees/emails",
      name: "Event EmailAttendees",
      component: EmailAttendees,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/attendees",
      name: "Event Information",
      component: Attendees,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/orders",
      name: "Event Orders",
      component: EventOrders,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/orders/:order_id",
      name: "Orders Details",
      component: OrderDetails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/pages",
      name: "Pages",
      component: Pages,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: "/event/:id/badges",
      name: "Event Badges",
      component: Badges,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/checkin",
      name: "Event Check-in",
      component: Checkin,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/preview",
      name: "Preview",
      component: Preview,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/design",
      name: "Design",
      component: Design,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/manage",
      name: "Manage",
      component: Manage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/exhibitors",
      name: "Exhibitors",
      component: Exhibitors,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/check-in",
      name: "Check-In",
      component: CheckIn,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/event/:id/reports",
      name: "Reports",
      component: Reports,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/help",
      name: "Help",
      component: Help,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/orders",
      name: "Orders",
      component: Orders,
      meta: {
        requiresAuth: true,
      }
    },
  ],
});

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next("/");
  } else {
    next();
  }
});

export default router;
